export default {"src":"/_next/static/media/cover3.28b6c9c8.svg","height":560,"width":1440};